export const formatCaseText = (text) => {
  if (text == null) return "";

  return String(text).replace(/<br\s*\/?>/gi, "\n");
};
